import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { CONTACT } from "../data/content";
import { Divider } from "./Primitives";

const QUICK = [
  { label: "About Us", to: "/about" },
  { label: "Areas of Focus", to: "/areas-of-focus" },
  { label: "Events", to: "/events" },
  { label: "Publications", to: "/publications" },
  { label: "Advisory Board", to: "/advisory-board" },
  { label: "Contact", to: "/contact" },
];

export const Footer = () => (
  <footer data-testid="footer" className="bg-amf-navy text-amf-cream pt-16 md:pt-20 pb-10">
    <div className="max-w-[1200px] mx-auto px-6 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <img
            src="/board/logo-circle.png"
            alt="Asana Memorial Foundation logo"
            className="h-16 w-16 rounded-full object-cover mb-4"
          />
          <h3 className="font-playfair text-2xl text-amf-cream">
            Asana Memorial Foundation
          </h3>
          <p className="font-playfair italic text-amf-gold mt-3 text-lg">
            Educate a girl. Change a generation.
          </p>
          <p className="font-lora text-amf-cream/70 mt-4 leading-relaxed text-sm max-w-xs">
            Advancing equitable access to education and life opportunities for
            girls and young women in Ghana.
          </p>
        </div>

        <div>
          <p className="amf-overline text-amf-gold mb-5">Quick Links</p>
          <ul className="space-y-3">
            {QUICK.map((q) => (
              <li key={q.to}>
                <Link
                  to={q.to}
                  className="font-lora text-amf-cream/80 hover:text-amf-gold transition-colors"
                >
                  {q.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="amf-overline text-amf-gold mb-5">Get In Touch</p>
          <ul className="space-y-3 font-lora text-amf-cream/80 text-sm">
            <li>{CONTACT.phone}</li>
            <li>
              <a href={`mailto:${CONTACT.email}`} className="hover:text-amf-gold transition-colors break-all">
                {CONTACT.email}
              </a>
            </li>
            <li className="leading-relaxed">{CONTACT.address}</li>
          </ul>
          <div className="flex items-center gap-4 mt-6">
            {[Facebook, Instagram, Linkedin, Twitter].map((Icon, i) => (
              <a
                key={i}
                href="#"
                aria-label="Social media"
                className="text-amf-cream/70 hover:text-amf-gold transition-colors"
              >
                <Icon size={20} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>
      </div>

      <Divider className="my-10 opacity-20" />
      <p className="amf-overline text-amf-stone text-center tracking-[0.15em]">
        © 2026 Asana Memorial Foundation. All rights reserved.
      </p>
    </div>
  </footer>
);
